<ion-button fill="clear" [disabled]="disabled" (click)="!disabled && click.emit()">
    <div class="inner">
        <ion-icon *ngIf="icon" [src]="icon"></ion-icon>
        <ion-img *ngIf="img" [src]="img"></ion-img>
        <ion-label>{{title}}</ion-label>
    </div>
</ion-button>
